import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgMap = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M15.5892 4.36501C15.2912 4.24584 14.9588 4.24584 14.6608 4.36501L9.33917 6.49418C9.0412 6.61334 8.70881 6.61334 8.41084 6.49418L3.48251 4.52251C3.38742 4.4844 3.28442 4.47025 3.18257 4.4813C3.08073 4.49235 2.98316 4.52827 2.89846 4.58589C2.81376 4.64351 2.74452 4.72107 2.69683 4.81173C2.64915 4.9024 2.62449 5.0034 2.62501 5.10584V17.0833C2.62497 17.3332 2.69981 17.5774 2.83989 17.7843C2.97996 17.9912 3.17884 18.1514 3.41084 18.2442L8.41084 20.2442C8.70881 20.3633 9.0412 20.3633 9.33917 20.2442L14.6608 18.115C14.9588 17.9958 15.2912 17.9958 15.5892 18.115L20.5175 20.0833C20.6126 20.1215 20.7156 20.1356 20.8174 20.1246C20.9193 20.1135 21.0169 20.0776 21.1016 20.02C21.1863 19.9623 21.2555 19.8848 21.3032 19.7941C21.3509 19.7035 21.3755 19.6025 21.375 19.5V7.52584C21.375 7.27597 21.3002 7.03182 21.1601 6.8249C21.0201 6.61798 20.8212 6.4578 20.5892 6.36501L15.5892 4.36501Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.875 6.58334V20.3333"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.125 4.27585V18.0258"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgMap.displayName = 'SvgMap';
export default SvgMap;
